import { createSlice } from '@reduxjs/toolkit'

import { ErrorAction, InitialErrorState } from './types'

const initialState: InitialErrorState = {
  errorData: undefined,
}

const ErrorSlice = createSlice({
  name: 'Error',
  initialState,
  reducers: {
    setError(state, action: ErrorAction) {
      state.errorData = action.payload
    },
    clearError(state) {
      state.errorData = undefined
    },
  },
})

const ErrorSliceReducer = ErrorSlice.reducer

export const { setError, clearError } = ErrorSlice.actions
export default ErrorSliceReducer
